import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ManageUsersPage } from '../../components/ManageUserPage';
export const Main = () => {
  return (
    <Switch>
      <Route path='/users/entry' component={ManageUsersPage} exact={true} />
      <Route path='/users/entry/:id' component={ManageUsersPage} exact={true} />
    </Switch>
  );
};
